import rh from "../assets/rh.png";
import tf from "../assets/tylkofans.webp";
import wpc from "../assets/wpc.png";
import wpa from "../assets/wpa.png";
import viva from "../assets/viva.png";
import only from "../assets/only.png";
function Career({lang, event}) {

    let locale = lang.work;
    return ( 
        <>
            <div className="career-block" id="apply">
                <div className="career-screen-bg"></div>
                <div className="container">
                    <div className="flex-items">
                        <h1 dangerouslySetInnerHTML={{ __html: locale.heading }} />
                        <div className="flex-links-container">
                            <h2>{locale.aff}</h2>
                            <div className="flex-links">
                                {/*
                                <div>
                                    <a href="https://onlyglance.com/" target="_blank">
                                        <img src={only} alt="onlyglance" />
                                        {/*<p className="to-link">onlyglance.com</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="https://tylkofans.pl" target="_blank">
                                        <img src={tf} alt="Tylkofans.pl" />
                                        <p className="to-link">tylkofans.pl</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="https://vivalachat.com/" target="_blank">
                                        <img src={viva} alt="viva la chat" />
                                        <span className="to-link">vivalachat.com</span>
                                    </a>
                                </div>
                                */}
                                <div>
                                    <a href="https://rhodiumsites.com" target="_blank">
                                        <img src={rh} alt="Rhodiumsites" />
                                        {/*<span className="to-link">rhodiumsites.com</span>*/}
                                    </a>
                                </div>
                                <div>
                                    <a href="https://wpafoundation.info" target="_blank">
                                        <img src={wpa} alt="Wpafoundation" />
                                        {/*<p className="to-link">wpafoundation.info</p>*/}
                                    </a>
                                </div>
                                <div>
                                    <a href="https://wpcfoundation.info" target="_blank">
                                        <img src={wpc} alt="Wpcfoundation" />
                                        {/*<p className="to-link">wpcfoundation.info</p>*/}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex">
                        <div>
                            <h2>{locale.element1}</h2>
                            <p>{locale.element2}</p>
                        </div>
                        <button className="btn-form" onClick={event}>{locale.element3}</button>
                    </div>
                    <div className="flex-links-container dp-flex-onsmall">
                        <h2>{locale.aff}</h2>
                            <div className="flex-links">
                                {/*
                                <div>
                                    <a href="https://onlyglance.com/" target="_blank">
                                        <img src={only} alt="onlyglance" />
                                        <p className="to-link">onlyglance.com</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="https://tylkofans.pl" target="_blank">
                                        <img src={tf} alt="Tylkofans.pl" />
                                        <p className="to-link">tylkofans.pl</p>
                                    </a>
                                </div>
                                <div>
                                    <a href="https://vivalachat.com/" target="_blank">
                                        <img src={viva} alt="viva la chat" />
                                        <span className="to-link">vivalachat.com</span>
                                    </a>
                                </div>
                                */}
                                <div>
                                    <a href="https://wpafoundation.info" target="_blank">
                                        <img src={wpa} alt="Wpafoundation" />
                                        {/*<p className="to-link">wpafoundation.info</p>*/}
                                    </a>
                                </div>
                                <div>
                                    <a href="https://wpcfoundation.info" target="_blank">
                                        <img src={wpc} alt="Wpcfoundation" />
                                        {/*<p className="to-link">wpcfoundation.info</p>*/}
                                    </a>
                                </div>
                                <div>
                                    <a href="https://rhodiumsites.com" target="_blank">
                                        <img src={rh} alt="Rhodiumsites" />
                                        {/*<span className="to-link">rhodiumsites.com</span>*/}
                                    </a>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </>
     );
}

export default Career;